var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: '',
  baseApiUrl: 'https://cepertam.centremedvie.com/api/',
  Regions: ['Kaloum', 'Dixinn', 'Ratoma', 'Matam', 'Matoto', 'Beyla', 'Boffa', 'Boké', 'Coyah', 'Dabola', 'Dalaba', 'Dinguiraye', 'Dubréka', 'Faranah', 'Forécariah', 'Fria', 'Gaoual', 'Guéckédou', 'Kankan', 'Kérouané', 'Kindia', 'Kissidougou', 'Koubia', 'Koundara', 'Kouroussa', 'Labé', 'Lélouma', 'Lola', 'Macenta', 'Mamou', 'Mandiana', 'Nzérékoré', 'Pita', 'Siguiri', 'Télimélé', 'Tougué', 'Yomou']
};
export default Common;